export default __webpack_public_path__ + "static/media/Rule19.ceba7f47.png";